import { useAlert, useToast } from "@apex/component-library";
import { SetAlert } from "@apex/component-library/components/Alert/types";
import { Toast } from "@apex/component-library/components/Toast/types";
import { ReactNode, useEffect, useState } from "react";
import { MutationCache, QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { useLocation } from "react-router-dom";

import onMutateError from "./onMutateError";

const createQueryClient = (
  setAlert: SetAlert,
  toast: (toast: Toast) => void
) => {
  const mutationCache = new MutationCache({
    onError: onMutateError(setAlert, toast),
  });
  return new QueryClient({
    mutationCache,
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        cacheTime: 0,
      },
      mutations: {
        retry: false,
      },
    },
  });
};

export function ReactQueryProvider({ children }: { children: ReactNode }) {
  const { setAlert, removeAllAlerts } = useAlert();
  const toast = useToast();
  const [queryClient] = useState(() => createQueryClient(setAlert, toast));

  const location = useLocation();
  useEffect(() => {
    removeAllAlerts();
  }, [location, removeAllAlerts]);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        {children}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  );
}
